export default function (Component) {
Component.options.__docs = "<p>You can bind multiple checkboxes to a single array. For each checked control it&#39;s corresponding value is added to the bound array.</p>\n"
}